import CustomMenuItem from './CustomMenuItem';
import React from 'react';

export default function CustomMenuItems({ items }) {
  return items.map((item, index) => {
    if (!item) return;

    const { img, linkAttr, text, ...attr } = item;

    return <CustomMenuItem key={'custom-menu-item-' + index} index={index} text={text} linkAttr={linkAttr} {...attr} />;
  });
}
